import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { getAllRoles } from 'auth/store/roles/selectors';
import { closeModal } from 'modal/store/actions';
import { createContact } from 'contacts/store/actions';
import ContactForm from 'contacts/containers/modal/ContactForm';


const CreateUserModal = ({
  name, createContact, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>New User</MainTitle>

    <ContactForm
      contact={{}}
      user={{}}
      isAdminForm
      isNewUser
      onSubmit={(contact) => {
        createContact(contact);
        closeModal(name);
      }}
    />

  </>
);
CreateUserModal.propTypes = {
  name: PropTypes.string.isRequired,
  createContact: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  roles: getAllRoles(state),
});
const mapDispatchToProps = {
  createContact,
  closeModal,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateUserModal);
